import React from 'react';
import Info from '../Info';
import Country from '../country';
import Cards from '../Cards';
import '../App.css';
import { Twitter, Mail, Instagram } from 'react-feather';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import MetaImg from '../assets/metaImg.png';
const LandingPageOriginal = () => {
  return (
    <div>
      <Helmet>
        <meta
          name='og:description'
          content='Welcome to Career Plant, your all in one resource, to grow and succeed in a new career!'
        />
        <meta property='og:image' content={MetaImg} />
      </Helmet>
      <div className='main'>
        <div>
          <Info
            title='Career Plant'
            image='./images/career-plant-logo.png'
            subtitle='Grow Your Career!'
          />
        </div>
      </div>

      <div className='mainCards'>
        <div className='cardsText'>
          <Cards
            title='Critical Thinking'
            subtitle='Explore an endless inventory of technical problems'
          />
        </div>
        <div className='cardsPhone'>
          <Country title='home' />
        </div>
      </div>

      <div className='mainCards'>
        <div className='cardsPhone'>
          <Country title='salary' />
        </div>
        <div className='cardsText'>
          <Cards
            title='Compensation Review'
            subtitle='Scroll through over 45k+ compensation submissions'
          />
        </div>
      </div>

      <div className='mainCards'>
        <div className='cardsText'>
          <Cards
            title='Revise'
            subtitle='Scroll through a never ending list of coding, behavioral, design questions asked at your favorite companies.'
          />
        </div>
        <div className='cardsPhone'>
          <Country title='questionList' />
        </div>
      </div>

      <div className='mainCards'>
        <div className='cardsPhone'>
          <Country title='contribute' />
        </div>
        <div className='cardsText'>
          <Cards
            title='Contribute Anonymously'
            subtitle='Submit your compensation anonymously and help build a more transparent community'
          />
        </div>
      </div>

      <div className='mainCards'>
        <div className='cardsText'>
          <Cards
            title='Be Prepared'
            subtitle='Resume Reviews and Mock Interviews'
          />
        </div>
        <div className='cardsPhone'>
          <Country title='review' />
        </div>
      </div>
      <div className='mainCards'>
        <div className='cardsText'>
          <section>
            <br />
            <br />
            <br />
            <h1>Career Plant</h1>
            <br />
            <h2>Coming Soon to the App Store</h2>
            <a href='#'>
              <img
                id='download'
                src='https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg'
              />
            </a>
            <div className='icons'>
              <a
                className='feather-icons'
                href='mailto:contact@careerplant.io'
                target='_blank'
                rel='noopener noreferrer'
              >
                {' '}
                <Mail
                  size={48}
                  fill={'black'}
                  stroke='white'
                  strokeWidth='0.5'
                />
              </a>
              <a
                className='feather-icons'
                href='https://twitter.com/careerplant_io'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Twitter
                  size={48}
                  fill={`black`}
                  stroke='white'
                  strokeWidth='0'
                />
              </a>
              <a
                className='feather-icons'
                href='https://www.instagram.com/careerplant.io/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <Instagram
                  size={48}
                  fill={'black'}
                  stroke='white'
                  strokeWidth='2'
                />
              </a>
            </div>
          </section>
        </div>
      </div>
      <footer>
        <span
          onClick={() =>
            window.open('https://airtable.com/shroFnSReXZypCkpx', '_blank')
          }
          className='sign-up-beta'
        >
          Sign up for Beta
        </span>
        <span className='terms'>
          <Link className='link' to='/terms'>
            Terms and Conditions
          </Link>
          <Link className='link' to='/privacy'>
            Privacy Policy
          </Link>
        </span>
      </footer>
    </div>
  );
};

export default LandingPageOriginal;
